import axios from "axios";
import React, { useEffect, useState } from "react";
import { jwtDecode, JwtPayload } from "jwt-decode";

import { useAccessToken, useJwtToken } from "@me8eon/react_authentication";
import { useTime } from "@me8eon/time";

export const tokenData = (token: string | undefined): any => {
    try {
        if (!token) return "No token";
        const decoded: JwtPayload = jwtDecode(token);
        const now = new Date();
        const expired = decoded.exp
            ? new Date(decoded.exp * 1000) < now
            : false;
        const expire = decoded.exp
            ? new Date(decoded.exp * 1000).toLocaleString()
            : "No expiry";
        const issuedAt = decoded.iat
            ? new Date(decoded.iat * 1000).toLocaleString()
            : "Not issued";
        return {
            ...decoded,
            expired,
            expire,
            issuedAt,
            now: now.toLocaleString(),
            email: (decoded as any).preferred_username,
        };
    } catch (error) {
        return `Invalid token or error decoding ${error}`;
    }
};


let lastDiagnostic: Promise<any> | null = null;
let lastTime: number = 0;
let count = 0;
let localCount = 0;
let gotDetails = 0;

export type DiagnosticsConfig = {
    staleness?: number
    apikey?: string
    showJwtToken?: boolean // defaults true
}

export async function useDiagnostics(config?: DiagnosticsConfig): Promise<any> {
    const { staleness = 10000 } = config || {};
    const time = useTime();
    const now = time().getTime();
    if (lastDiagnostic === null || now - lastTime > staleness) {
        const apikey = config?.apikey || await useAccessToken("dls");
        const url = window.location.href.includes("localhost")
            ? `https://dev-myhelp.eon.com`
            : "";
        lastDiagnostic = axios
            .get(`${url}/apikey/check/${apikey}`)
            .then((res) => {
                const data = res.data;
                const { results, ...rest } = data;
                return {
                    ...rest,
                    permissions: Object.values(results || {})[0],
                };
            });
        lastDiagnostic.then(() => gotDetails++);
        lastTime = now;
    }
    return lastDiagnostic as Promise<any>;
}

export type DiagnosticsProps = {
    config?: DiagnosticsConfig
}

export function Diagnostics({ config }: DiagnosticsProps) {
    count++;
    const [diagnostics, setDiagnostics] = useState<any>("No apikey");
    const jwtTokens = useJwtToken();
    const [jwt, setJwt] = useState<string | undefined>("loading token");
    useEffect(() => {
        jwtTokens().then(t => setJwt(t));
    }, [jwtTokens]);
    localCount++;
    useDiagnostics(config).then((d) => {
        if (d !== diagnostics) setDiagnostics(d);
    });
    return (
        <div>
            {config?.showJwtToken !== false && <>
                <hr />
                <pre>JwtTokens: {JSON.stringify(jwt, null, 2)}</pre>
            </>}
            <hr />
            <pre>Apikey: {JSON.stringify(diagnostics, null, 2)}</pre>
            <hr />
            Calling stats:
            <ul>
                <li>Displayed: {count}</li>
                <li>Set state: {localCount}</li>
                <li>Got details: {gotDetails}</li>
            </ul>
        </div>
    );
}
